import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { EditorCommand, registerEditorCommand } from '../../browser/editorExtensions.js';
import { ReplaceCommand } from '../../common/commands/replaceCommand.js';
import { CursorState } from '../../common/controller/cursorCommon.js';
import { WordOperations } from '../../common/controller/cursorWordOperations.js';
import { getMapForWordSeparators } from '../../common/controller/wordCharacterClassifier.js';
import { Position } from '../../common/core/position.js';
import { Range } from '../../common/core/range.js';
import { Selection } from '../../common/core/selection.js';
import { EditorContextKeys } from '../../common/editorContextKeys.js';
import { CONTEXT_ACCESSIBILITY_MODE_ENABLED } from '../../../platform/accessibility/common/accessibility.js';
import { ContextKeyExpr } from '../../../platform/contextkey/common/contextkey.js';
import { EditorOptions } from '../../common/config/editorOptions.js';
export var MoveWordCommand = /*#__PURE__*/function (_EditorCommand) {
  _inherits(MoveWordCommand, _EditorCommand);

  var _super = _createSuper(MoveWordCommand);

  function MoveWordCommand(opts) {
    var _this;

    _classCallCheck(this, MoveWordCommand);

    _this = _super.call(this, opts);
    _this._inSelectionMode = opts.inSelectionMode;
    _this._wordNavigationType = opts.wordNavigationType;
    return _this;
  }

  _createClass(MoveWordCommand, [{
    key: "runEditorCommand",
    value: function runEditorCommand(accessor, editor, args) {
      var _this2 = this;

      if (!editor.hasModel()) {
        return;
      }

      var wordSeparators = getMapForWordSeparators(editor.getOption(105
      /* wordSeparators */
      ));
      var model = editor.getModel();
      var selections = editor.getSelections();
      var result = selections.map(function (sel) {
        var inPosition = new Position(sel.positionLineNumber, sel.positionColumn);

        var outPosition = _this2._move(wordSeparators, model, inPosition, _this2._wordNavigationType);

        return _this2._moveTo(sel, outPosition, _this2._inSelectionMode);
      });
      model.pushStackElement();

      editor._getViewModel().setCursorStates('moveWordCommand', 0
      /* NotSet */
      , result.map(function (r) {
        return CursorState.fromModelSelection(r);
      }));

      if (result.length === 1) {
        var pos = new Position(result[0].positionLineNumber, result[0].positionColumn);
        editor.revealPosition(pos, 0
        /* Smooth */
        );
      }
    }
  }, {
    key: "_moveTo",
    value: function _moveTo(from, to, inSelectionMode) {
      if (inSelectionMode) {
        // move just position
        return new Selection(from.selectionStartLineNumber, from.selectionStartColumn, to.lineNumber, to.column);
      } else {
        // move everything
        return new Selection(to.lineNumber, to.column, to.lineNumber, to.column);
      }
    }
  }]);

  return MoveWordCommand;
}(EditorCommand);
export var WordLeftCommand = /*#__PURE__*/function (_MoveWordCommand) {
  _inherits(WordLeftCommand, _MoveWordCommand);

  var _super2 = _createSuper(WordLeftCommand);

  function WordLeftCommand() {
    _classCallCheck(this, WordLeftCommand);

    return _super2.apply(this, arguments);
  }

  _createClass(WordLeftCommand, [{
    key: "_move",
    value: function _move(wordSeparators, model, position, wordNavigationType) {
      return WordOperations.moveWordLeft(wordSeparators, model, position, wordNavigationType);
    }
  }]);

  return WordLeftCommand;
}(MoveWordCommand);
export var WordRightCommand = /*#__PURE__*/function (_MoveWordCommand2) {
  _inherits(WordRightCommand, _MoveWordCommand2);

  var _super3 = _createSuper(WordRightCommand);

  function WordRightCommand() {
    _classCallCheck(this, WordRightCommand);

    return _super3.apply(this, arguments);
  }

  _createClass(WordRightCommand, [{
    key: "_move",
    value: function _move(wordSeparators, model, position, wordNavigationType) {
      return WordOperations.moveWordRight(wordSeparators, model, position, wordNavigationType);
    }
  }]);

  return WordRightCommand;
}(MoveWordCommand);
export var CursorWordStartLeft = /*#__PURE__*/function (_WordLeftCommand) {
  _inherits(CursorWordStartLeft, _WordLeftCommand);

  var _super4 = _createSuper(CursorWordStartLeft);

  function CursorWordStartLeft() {
    _classCallCheck(this, CursorWordStartLeft);

    return _super4.call(this, {
      inSelectionMode: false,
      wordNavigationType: 0
      /* WordStart */
      ,
      id: 'cursorWordStartLeft',
      precondition: undefined
    });
  }

  return CursorWordStartLeft;
}(WordLeftCommand);
export var CursorWordEndLeft = /*#__PURE__*/function (_WordLeftCommand2) {
  _inherits(CursorWordEndLeft, _WordLeftCommand2);

  var _super5 = _createSuper(CursorWordEndLeft);

  function CursorWordEndLeft() {
    _classCallCheck(this, CursorWordEndLeft);

    return _super5.call(this, {
      inSelectionMode: false,
      wordNavigationType: 2
      /* WordEnd */
      ,
      id: 'cursorWordEndLeft',
      precondition: undefined
    });
  }

  return CursorWordEndLeft;
}(WordLeftCommand);
export var CursorWordLeft = /*#__PURE__*/function (_WordLeftCommand3) {
  _inherits(CursorWordLeft, _WordLeftCommand3);

  var _super6 = _createSuper(CursorWordLeft);

  function CursorWordLeft() {
    _classCallCheck(this, CursorWordLeft);

    return _super6.call(this, {
      inSelectionMode: false,
      wordNavigationType: 1
      /* WordStartFast */
      ,
      id: 'cursorWordLeft',
      precondition: undefined,
      kbOpts: {
        kbExpr: EditorContextKeys.textInputFocus,
        primary: 2048
        /* CtrlCmd */
        | 15
        /* LeftArrow */
        ,
        mac: {
          primary: 512
          /* Alt */
          | 15
          /* LeftArrow */

        },
        weight: 100
        /* EditorContrib */

      }
    });
  }

  return CursorWordLeft;
}(WordLeftCommand);
export var CursorWordStartLeftSelect = /*#__PURE__*/function (_WordLeftCommand4) {
  _inherits(CursorWordStartLeftSelect, _WordLeftCommand4);

  var _super7 = _createSuper(CursorWordStartLeftSelect);

  function CursorWordStartLeftSelect() {
    _classCallCheck(this, CursorWordStartLeftSelect);

    return _super7.call(this, {
      inSelectionMode: true,
      wordNavigationType: 0
      /* WordStart */
      ,
      id: 'cursorWordStartLeftSelect',
      precondition: undefined
    });
  }

  return CursorWordStartLeftSelect;
}(WordLeftCommand);
export var CursorWordEndLeftSelect = /*#__PURE__*/function (_WordLeftCommand5) {
  _inherits(CursorWordEndLeftSelect, _WordLeftCommand5);

  var _super8 = _createSuper(CursorWordEndLeftSelect);

  function CursorWordEndLeftSelect() {
    _classCallCheck(this, CursorWordEndLeftSelect);

    return _super8.call(this, {
      inSelectionMode: true,
      wordNavigationType: 2
      /* WordEnd */
      ,
      id: 'cursorWordEndLeftSelect',
      precondition: undefined
    });
  }

  return CursorWordEndLeftSelect;
}(WordLeftCommand);
export var CursorWordLeftSelect = /*#__PURE__*/function (_WordLeftCommand6) {
  _inherits(CursorWordLeftSelect, _WordLeftCommand6);

  var _super9 = _createSuper(CursorWordLeftSelect);

  function CursorWordLeftSelect() {
    _classCallCheck(this, CursorWordLeftSelect);

    return _super9.call(this, {
      inSelectionMode: true,
      wordNavigationType: 1
      /* WordStartFast */
      ,
      id: 'cursorWordLeftSelect',
      precondition: undefined,
      kbOpts: {
        kbExpr: EditorContextKeys.textInputFocus,
        primary: 2048
        /* CtrlCmd */
        | 1024
        /* Shift */
        | 15
        /* LeftArrow */
        ,
        mac: {
          primary: 512
          /* Alt */
          | 1024
          /* Shift */
          | 15
          /* LeftArrow */

        },
        weight: 100
        /* EditorContrib */

      }
    });
  }

  return CursorWordLeftSelect;
}(WordLeftCommand); // Accessibility navigation commands should only be enabled on windows since they are tuned to what NVDA expects

export var CursorWordAccessibilityLeft = /*#__PURE__*/function (_WordLeftCommand7) {
  _inherits(CursorWordAccessibilityLeft, _WordLeftCommand7);

  var _super10 = _createSuper(CursorWordAccessibilityLeft);

  function CursorWordAccessibilityLeft() {
    _classCallCheck(this, CursorWordAccessibilityLeft);

    return _super10.call(this, {
      inSelectionMode: false,
      wordNavigationType: 3
      /* WordAccessibility */
      ,
      id: 'cursorWordAccessibilityLeft',
      precondition: undefined,
      kbOpts: {
        kbExpr: ContextKeyExpr.and(EditorContextKeys.textInputFocus, CONTEXT_ACCESSIBILITY_MODE_ENABLED),
        win: {
          primary: 2048
          /* CtrlCmd */
          | 15
          /* LeftArrow */

        },
        weight: 100
        /* EditorContrib */
        + 1
      }
    });
  }

  _createClass(CursorWordAccessibilityLeft, [{
    key: "_move",
    value: function _move(_, model, position, wordNavigationType) {
      return _get(_getPrototypeOf(CursorWordAccessibilityLeft.prototype), "_move", this).call(this, getMapForWordSeparators(EditorOptions.wordSeparators.defaultValue), model, position, wordNavigationType);
    }
  }]);

  return CursorWordAccessibilityLeft;
}(WordLeftCommand);
export var CursorWordAccessibilityLeftSelect = /*#__PURE__*/function (_WordLeftCommand8) {
  _inherits(CursorWordAccessibilityLeftSelect, _WordLeftCommand8);

  var _super11 = _createSuper(CursorWordAccessibilityLeftSelect);

  function CursorWordAccessibilityLeftSelect() {
    _classCallCheck(this, CursorWordAccessibilityLeftSelect);

    return _super11.call(this, {
      inSelectionMode: true,
      wordNavigationType: 3
      /* WordAccessibility */
      ,
      id: 'cursorWordAccessibilityLeftSelect',
      precondition: undefined,
      kbOpts: {
        kbExpr: ContextKeyExpr.and(EditorContextKeys.textInputFocus, CONTEXT_ACCESSIBILITY_MODE_ENABLED),
        win: {
          primary: 2048
          /* CtrlCmd */
          | 1024
          /* Shift */
          | 15
          /* LeftArrow */

        },
        weight: 100
        /* EditorContrib */
        + 1
      }
    });
  }

  _createClass(CursorWordAccessibilityLeftSelect, [{
    key: "_move",
    value: function _move(_, model, position, wordNavigationType) {
      return _get(_getPrototypeOf(CursorWordAccessibilityLeftSelect.prototype), "_move", this).call(this, getMapForWordSeparators(EditorOptions.wordSeparators.defaultValue), model, position, wordNavigationType);
    }
  }]);

  return CursorWordAccessibilityLeftSelect;
}(WordLeftCommand);
export var CursorWordStartRight = /*#__PURE__*/function (_WordRightCommand) {
  _inherits(CursorWordStartRight, _WordRightCommand);

  var _super12 = _createSuper(CursorWordStartRight);

  function CursorWordStartRight() {
    _classCallCheck(this, CursorWordStartRight);

    return _super12.call(this, {
      inSelectionMode: false,
      wordNavigationType: 0
      /* WordStart */
      ,
      id: 'cursorWordStartRight',
      precondition: undefined
    });
  }

  return CursorWordStartRight;
}(WordRightCommand);
export var CursorWordEndRight = /*#__PURE__*/function (_WordRightCommand2) {
  _inherits(CursorWordEndRight, _WordRightCommand2);

  var _super13 = _createSuper(CursorWordEndRight);

  function CursorWordEndRight() {
    _classCallCheck(this, CursorWordEndRight);

    return _super13.call(this, {
      inSelectionMode: false,
      wordNavigationType: 2
      /* WordEnd */
      ,
      id: 'cursorWordEndRight',
      precondition: undefined,
      kbOpts: {
        kbExpr: EditorContextKeys.textInputFocus,
        primary: 2048
        /* CtrlCmd */
        | 17
        /* RightArrow */
        ,
        mac: {
          primary: 512
          /* Alt */
          | 17
          /* RightArrow */

        },
        weight: 100
        /* EditorContrib */

      }
    });
  }

  return CursorWordEndRight;
}(WordRightCommand);
export var CursorWordRight = /*#__PURE__*/function (_WordRightCommand3) {
  _inherits(CursorWordRight, _WordRightCommand3);

  var _super14 = _createSuper(CursorWordRight);

  function CursorWordRight() {
    _classCallCheck(this, CursorWordRight);

    return _super14.call(this, {
      inSelectionMode: false,
      wordNavigationType: 2
      /* WordEnd */
      ,
      id: 'cursorWordRight',
      precondition: undefined
    });
  }

  return CursorWordRight;
}(WordRightCommand);
export var CursorWordStartRightSelect = /*#__PURE__*/function (_WordRightCommand4) {
  _inherits(CursorWordStartRightSelect, _WordRightCommand4);

  var _super15 = _createSuper(CursorWordStartRightSelect);

  function CursorWordStartRightSelect() {
    _classCallCheck(this, CursorWordStartRightSelect);

    return _super15.call(this, {
      inSelectionMode: true,
      wordNavigationType: 0
      /* WordStart */
      ,
      id: 'cursorWordStartRightSelect',
      precondition: undefined
    });
  }

  return CursorWordStartRightSelect;
}(WordRightCommand);
export var CursorWordEndRightSelect = /*#__PURE__*/function (_WordRightCommand5) {
  _inherits(CursorWordEndRightSelect, _WordRightCommand5);

  var _super16 = _createSuper(CursorWordEndRightSelect);

  function CursorWordEndRightSelect() {
    _classCallCheck(this, CursorWordEndRightSelect);

    return _super16.call(this, {
      inSelectionMode: true,
      wordNavigationType: 2
      /* WordEnd */
      ,
      id: 'cursorWordEndRightSelect',
      precondition: undefined,
      kbOpts: {
        kbExpr: EditorContextKeys.textInputFocus,
        primary: 2048
        /* CtrlCmd */
        | 1024
        /* Shift */
        | 17
        /* RightArrow */
        ,
        mac: {
          primary: 512
          /* Alt */
          | 1024
          /* Shift */
          | 17
          /* RightArrow */

        },
        weight: 100
        /* EditorContrib */

      }
    });
  }

  return CursorWordEndRightSelect;
}(WordRightCommand);
export var CursorWordRightSelect = /*#__PURE__*/function (_WordRightCommand6) {
  _inherits(CursorWordRightSelect, _WordRightCommand6);

  var _super17 = _createSuper(CursorWordRightSelect);

  function CursorWordRightSelect() {
    _classCallCheck(this, CursorWordRightSelect);

    return _super17.call(this, {
      inSelectionMode: true,
      wordNavigationType: 2
      /* WordEnd */
      ,
      id: 'cursorWordRightSelect',
      precondition: undefined
    });
  }

  return CursorWordRightSelect;
}(WordRightCommand);
export var CursorWordAccessibilityRight = /*#__PURE__*/function (_WordRightCommand7) {
  _inherits(CursorWordAccessibilityRight, _WordRightCommand7);

  var _super18 = _createSuper(CursorWordAccessibilityRight);

  function CursorWordAccessibilityRight() {
    _classCallCheck(this, CursorWordAccessibilityRight);

    return _super18.call(this, {
      inSelectionMode: false,
      wordNavigationType: 3
      /* WordAccessibility */
      ,
      id: 'cursorWordAccessibilityRight',
      precondition: undefined,
      kbOpts: {
        kbExpr: ContextKeyExpr.and(EditorContextKeys.textInputFocus, CONTEXT_ACCESSIBILITY_MODE_ENABLED),
        win: {
          primary: 2048
          /* CtrlCmd */
          | 17
          /* RightArrow */

        },
        weight: 100
        /* EditorContrib */
        + 1
      }
    });
  }

  _createClass(CursorWordAccessibilityRight, [{
    key: "_move",
    value: function _move(_, model, position, wordNavigationType) {
      return _get(_getPrototypeOf(CursorWordAccessibilityRight.prototype), "_move", this).call(this, getMapForWordSeparators(EditorOptions.wordSeparators.defaultValue), model, position, wordNavigationType);
    }
  }]);

  return CursorWordAccessibilityRight;
}(WordRightCommand);
export var CursorWordAccessibilityRightSelect = /*#__PURE__*/function (_WordRightCommand8) {
  _inherits(CursorWordAccessibilityRightSelect, _WordRightCommand8);

  var _super19 = _createSuper(CursorWordAccessibilityRightSelect);

  function CursorWordAccessibilityRightSelect() {
    _classCallCheck(this, CursorWordAccessibilityRightSelect);

    return _super19.call(this, {
      inSelectionMode: true,
      wordNavigationType: 3
      /* WordAccessibility */
      ,
      id: 'cursorWordAccessibilityRightSelect',
      precondition: undefined,
      kbOpts: {
        kbExpr: ContextKeyExpr.and(EditorContextKeys.textInputFocus, CONTEXT_ACCESSIBILITY_MODE_ENABLED),
        win: {
          primary: 2048
          /* CtrlCmd */
          | 1024
          /* Shift */
          | 17
          /* RightArrow */

        },
        weight: 100
        /* EditorContrib */
        + 1
      }
    });
  }

  _createClass(CursorWordAccessibilityRightSelect, [{
    key: "_move",
    value: function _move(_, model, position, wordNavigationType) {
      return _get(_getPrototypeOf(CursorWordAccessibilityRightSelect.prototype), "_move", this).call(this, getMapForWordSeparators(EditorOptions.wordSeparators.defaultValue), model, position, wordNavigationType);
    }
  }]);

  return CursorWordAccessibilityRightSelect;
}(WordRightCommand);
export var DeleteWordCommand = /*#__PURE__*/function (_EditorCommand2) {
  _inherits(DeleteWordCommand, _EditorCommand2);

  var _super20 = _createSuper(DeleteWordCommand);

  function DeleteWordCommand(opts) {
    var _this3;

    _classCallCheck(this, DeleteWordCommand);

    _this3 = _super20.call(this, opts);
    _this3._whitespaceHeuristics = opts.whitespaceHeuristics;
    _this3._wordNavigationType = opts.wordNavigationType;
    return _this3;
  }

  _createClass(DeleteWordCommand, [{
    key: "runEditorCommand",
    value: function runEditorCommand(accessor, editor, args) {
      var _this4 = this;

      if (!editor.hasModel()) {
        return;
      }

      var wordSeparators = getMapForWordSeparators(editor.getOption(105
      /* wordSeparators */
      ));
      var model = editor.getModel();
      var selections = editor.getSelections();
      var commands = selections.map(function (sel) {
        var deleteRange = _this4._delete(wordSeparators, model, sel, _this4._whitespaceHeuristics, _this4._wordNavigationType);

        return new ReplaceCommand(deleteRange, '');
      });
      editor.pushUndoStop();
      editor.executeCommands(this.id, commands);
      editor.pushUndoStop();
    }
  }]);

  return DeleteWordCommand;
}(EditorCommand);
export var DeleteWordLeftCommand = /*#__PURE__*/function (_DeleteWordCommand) {
  _inherits(DeleteWordLeftCommand, _DeleteWordCommand);

  var _super21 = _createSuper(DeleteWordLeftCommand);

  function DeleteWordLeftCommand() {
    _classCallCheck(this, DeleteWordLeftCommand);

    return _super21.apply(this, arguments);
  }

  _createClass(DeleteWordLeftCommand, [{
    key: "_delete",
    value: function _delete(wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType) {
      var r = WordOperations.deleteWordLeft(wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType);

      if (r) {
        return r;
      }

      return new Range(1, 1, 1, 1);
    }
  }]);

  return DeleteWordLeftCommand;
}(DeleteWordCommand);
export var DeleteWordRightCommand = /*#__PURE__*/function (_DeleteWordCommand2) {
  _inherits(DeleteWordRightCommand, _DeleteWordCommand2);

  var _super22 = _createSuper(DeleteWordRightCommand);

  function DeleteWordRightCommand() {
    _classCallCheck(this, DeleteWordRightCommand);

    return _super22.apply(this, arguments);
  }

  _createClass(DeleteWordRightCommand, [{
    key: "_delete",
    value: function _delete(wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType) {
      var r = WordOperations.deleteWordRight(wordSeparators, model, selection, whitespaceHeuristics, wordNavigationType);

      if (r) {
        return r;
      }

      var lineCount = model.getLineCount();
      var maxColumn = model.getLineMaxColumn(lineCount);
      return new Range(lineCount, maxColumn, lineCount, maxColumn);
    }
  }]);

  return DeleteWordRightCommand;
}(DeleteWordCommand);
export var DeleteWordStartLeft = /*#__PURE__*/function (_DeleteWordLeftComman) {
  _inherits(DeleteWordStartLeft, _DeleteWordLeftComman);

  var _super23 = _createSuper(DeleteWordStartLeft);

  function DeleteWordStartLeft() {
    _classCallCheck(this, DeleteWordStartLeft);

    return _super23.call(this, {
      whitespaceHeuristics: false,
      wordNavigationType: 0
      /* WordStart */
      ,
      id: 'deleteWordStartLeft',
      precondition: EditorContextKeys.writable
    });
  }

  return DeleteWordStartLeft;
}(DeleteWordLeftCommand);
export var DeleteWordEndLeft = /*#__PURE__*/function (_DeleteWordLeftComman2) {
  _inherits(DeleteWordEndLeft, _DeleteWordLeftComman2);

  var _super24 = _createSuper(DeleteWordEndLeft);

  function DeleteWordEndLeft() {
    _classCallCheck(this, DeleteWordEndLeft);

    return _super24.call(this, {
      whitespaceHeuristics: false,
      wordNavigationType: 2
      /* WordEnd */
      ,
      id: 'deleteWordEndLeft',
      precondition: EditorContextKeys.writable
    });
  }

  return DeleteWordEndLeft;
}(DeleteWordLeftCommand);
export var DeleteWordLeft = /*#__PURE__*/function (_DeleteWordLeftComman3) {
  _inherits(DeleteWordLeft, _DeleteWordLeftComman3);

  var _super25 = _createSuper(DeleteWordLeft);

  function DeleteWordLeft() {
    _classCallCheck(this, DeleteWordLeft);

    return _super25.call(this, {
      whitespaceHeuristics: true,
      wordNavigationType: 0
      /* WordStart */
      ,
      id: 'deleteWordLeft',
      precondition: EditorContextKeys.writable,
      kbOpts: {
        kbExpr: EditorContextKeys.textInputFocus,
        primary: 2048
        /* CtrlCmd */
        | 1
        /* Backspace */
        ,
        mac: {
          primary: 512
          /* Alt */
          | 1
          /* Backspace */

        },
        weight: 100
        /* EditorContrib */

      }
    });
  }

  return DeleteWordLeft;
}(DeleteWordLeftCommand);
export var DeleteWordStartRight = /*#__PURE__*/function (_DeleteWordRightComma) {
  _inherits(DeleteWordStartRight, _DeleteWordRightComma);

  var _super26 = _createSuper(DeleteWordStartRight);

  function DeleteWordStartRight() {
    _classCallCheck(this, DeleteWordStartRight);

    return _super26.call(this, {
      whitespaceHeuristics: false,
      wordNavigationType: 0
      /* WordStart */
      ,
      id: 'deleteWordStartRight',
      precondition: EditorContextKeys.writable
    });
  }

  return DeleteWordStartRight;
}(DeleteWordRightCommand);
export var DeleteWordEndRight = /*#__PURE__*/function (_DeleteWordRightComma2) {
  _inherits(DeleteWordEndRight, _DeleteWordRightComma2);

  var _super27 = _createSuper(DeleteWordEndRight);

  function DeleteWordEndRight() {
    _classCallCheck(this, DeleteWordEndRight);

    return _super27.call(this, {
      whitespaceHeuristics: false,
      wordNavigationType: 2
      /* WordEnd */
      ,
      id: 'deleteWordEndRight',
      precondition: EditorContextKeys.writable
    });
  }

  return DeleteWordEndRight;
}(DeleteWordRightCommand);
export var DeleteWordRight = /*#__PURE__*/function (_DeleteWordRightComma3) {
  _inherits(DeleteWordRight, _DeleteWordRightComma3);

  var _super28 = _createSuper(DeleteWordRight);

  function DeleteWordRight() {
    _classCallCheck(this, DeleteWordRight);

    return _super28.call(this, {
      whitespaceHeuristics: true,
      wordNavigationType: 2
      /* WordEnd */
      ,
      id: 'deleteWordRight',
      precondition: EditorContextKeys.writable,
      kbOpts: {
        kbExpr: EditorContextKeys.textInputFocus,
        primary: 2048
        /* CtrlCmd */
        | 20
        /* Delete */
        ,
        mac: {
          primary: 512
          /* Alt */
          | 20
          /* Delete */

        },
        weight: 100
        /* EditorContrib */

      }
    });
  }

  return DeleteWordRight;
}(DeleteWordRightCommand);
registerEditorCommand(new CursorWordStartLeft());
registerEditorCommand(new CursorWordEndLeft());
registerEditorCommand(new CursorWordLeft());
registerEditorCommand(new CursorWordStartLeftSelect());
registerEditorCommand(new CursorWordEndLeftSelect());
registerEditorCommand(new CursorWordLeftSelect());
registerEditorCommand(new CursorWordStartRight());
registerEditorCommand(new CursorWordEndRight());
registerEditorCommand(new CursorWordRight());
registerEditorCommand(new CursorWordStartRightSelect());
registerEditorCommand(new CursorWordEndRightSelect());
registerEditorCommand(new CursorWordRightSelect());
registerEditorCommand(new CursorWordAccessibilityLeft());
registerEditorCommand(new CursorWordAccessibilityLeftSelect());
registerEditorCommand(new CursorWordAccessibilityRight());
registerEditorCommand(new CursorWordAccessibilityRightSelect());
registerEditorCommand(new DeleteWordStartLeft());
registerEditorCommand(new DeleteWordEndLeft());
registerEditorCommand(new DeleteWordLeft());
registerEditorCommand(new DeleteWordStartRight());
registerEditorCommand(new DeleteWordEndRight());
registerEditorCommand(new DeleteWordRight());